var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5V5.5C18 5.23478 17.8946 4.98043 17.7071 4.79289C17.5196 4.60536 17.2652 4.5 17 4.5H6.5C6.40714 4.5 6.31612 4.52586 6.23713 4.57467C6.15815 4.62349 6.09431 4.69334 6.05279 4.77639C6.01126 4.85945 5.99368 4.95242 6.00202 5.0449C6.01036 5.13738 6.04429 5.22572 6.1 5.3L10.6 11.3C10.8596 11.6462 11 12.0673 11 12.5C11 12.9327 10.8596 13.3538 10.6 13.7L6.1 19.7C6.04429 19.7743 6.01036 19.8626 6.00202 19.9551C5.99368 20.0476 6.01126 20.1406 6.05279 20.2236C6.09431 20.3067 6.15815 20.3765 6.23713 20.4253C6.31612 20.4741 6.40714 20.5 6.5 20.5H17C17.2652 20.5 17.5196 20.3946 17.7071 20.2071C17.8946 20.0196 18 19.7652 18 19.5V17.5",
    stroke: "#4B629E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigma);
export default __webpack_public_path__ + "static/media/sigma.c181575eceaa43f477fdd8b95bf14eaa.svg";
export { ForwardRef as ReactComponent };